import { useQuery } from "@tanstack/react-query";
import { SystemNotificationMessage } from "@graylog/server-api";
import NotificationsFactory from "components/notifications/NotificationsFactory";
import { NOTIFICATIONS_QUERY_KEY } from "components/notifications/constants";
const fetchNotificationMessage = (notification) => {
  const values = NotificationsFactory.getValuesForNotification(notification);
  const type = notification.type.toLocaleUpperCase();
  return notification.key ? SystemNotificationMessage.renderHtmlWithKey(type, notification.key, values) : SystemNotificationMessage.renderHtml(type, values);
};
const useNotificationMessage = (notification) => {
  const { data } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [...NOTIFICATIONS_QUERY_KEY, "message", notification.id, notification.key, notification.type],
    queryFn: () => fetchNotificationMessage(notification)
  });
  return data;
};
export default useNotificationMessage;
